var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { observer } from '@formily/reactive-vue';
import { isVoidField } from '@formily/core';
import { connect, mapProps, mapReadPretty, h } from '@formily/vue';
import { defineComponent } from '@vue/composition-api';
import { Field as VanInput } from 'vant';
import { resolveComponent } from '../__builtins__/shared';
import { stylePrefix } from '../__builtins__/configs';
import { PreviewText } from '../preview-text';
export var BaseInput = observer(defineComponent({
    name: 'FBaseInput',
    props: {
        label: {},
    },
    setup: function (props, _a) {
        var attrs = _a.attrs, slots = _a.slots, listeners = _a.listeners;
        return function () {
            var _a;
            return h(VanInput, {
                class: (_a = {}, _a["".concat(stylePrefix, "-input-asterisk")] = attrs.asterisk, _a),
                attrs: __assign(__assign({}, attrs), props),
                on: listeners,
            }, slots);
        };
    },
}));
export var inputValidate = mapProps({ validateStatus: true, title: 'label', required: true }, function (props, field) {
    if (isVoidField(field))
        return props;
    if (!field)
        return props;
    var takeMessage = function () {
        var split = function (messages) {
            return messages.reduce(function (buf, text, index) {
                if (!text)
                    return buf;
                return index < messages.length - 1
                    ? buf.concat([text, ', '])
                    : buf.concat([text]);
            }, []);
        };
        if (field.validating)
            return;
        if (props.feedbackText)
            return props.feedbackText;
        if (field.selfErrors.length)
            return split(field.selfErrors);
        if (field.selfWarnings.length)
            return split(field.selfWarnings);
        if (field.selfSuccesses.length)
            return split(field.selfSuccesses);
    };
    var errorMessages = takeMessage();
    return {
        errorMessage: resolveComponent(Array.isArray(errorMessages) ? errorMessages.join('') : errorMessages),
        extra: props.extra || field.description,
    };
}, function (props, field) {
    var _a;
    if (isVoidField(field))
        return props;
    if (!field)
        return props;
    return {
        feedbackStatus: field.validateStatus === 'validating'
            ? 'pending'
            : (Array.isArray(field.decorator) &&
                ((_a = field.decorator[1]) === null || _a === void 0 ? void 0 : _a.feedbackStatus)) ||
                field.validateStatus,
    };
}, function (props, field) {
    if (isVoidField(field))
        return props;
    if (!field)
        return props;
    var asterisk = false;
    if (field.required && field.pattern !== 'readPretty') {
        asterisk = true;
    }
    if ('asterisk' in props) {
        asterisk = props.asterisk;
    }
    return {
        asterisk: asterisk,
    };
});
export var Input = connect(BaseInput, mapReadPretty(PreviewText.Input), inputValidate);
export default Input;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vant/esm/input/index.js
// module id = null
// module chunks = 